import React from "react";

const Portada = () => {
  return (
    <div id="banner">
      <div className="infoBanner">
        <h1>Cafe Buda</h1>
        {/* <span></span> */}
      </div>
    </div>
  );
};

export default Portada;
